import React from 'react'
import _isEmpty from 'lodash/isEmpty'
import _extend from 'lodash/extend'
import {itemStyle, phoenixInfoStyle, phoenixIconStyle} from '../shared/styles'

const renderIcon = ({text, color = 'black', background = 'white'}) => {
    if (_isEmpty(text)) {
        return null
    }

    if (text.indexOf('fa ') >= 0) {
        return (
            <i
                className={`${text} phoenix-item-icon`}
                style={_extend({color, background}, phoenixIconStyle)}
                aria-hidden="true"
            />
        )
    }
    return (
        <i
            className="material-icons phoenix-item-icon"
            style={_extend({color, background}, phoenixIconStyle)}
        >
            {text}
        </i>
    )
}
const PhoenixSelectItem = ({displayIcon, children}) => (
    <div className="phoenix-item" style={itemStyle}>
        <div className="item-info" style={phoenixInfoStyle}>
            {_isEmpty(displayIcon) ? null : renderIcon(displayIcon)}
            <div>{children}</div>
        </div>
    </div>
)

PhoenixSelectItem.displayName = 'PhoenixSelectItem'

export default PhoenixSelectItem
